import React from "react";
import {
	Card,
	CardBody,
	CardTitle,
	Row,
	Col,

} from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';

import {
	StatisticsReport
} from '../../components/statistics-report/';

class StatisticsReportView extends React.Component {

	constructor(props) {
    super(props);

  }

	componentDidMount() {

	}

	render() {
		return (
			<div>
				<Row>
					<Col md="12">
            <StatisticsReport />
					</Col>
				</Row>
			</div>
		);
	}
}

export default StatisticsReportView;
